export default {
  id: 196,
  title: 'Target #196 - Tree',
  url: 'https://cssbattle.dev/play/196',
  colors: ['#90D3A6', '#024817'],
  solution:
    '<p a><p b><p c><p d><style>p[c],p[d]{top:91.5;width:70;height:20}p[a],p[c],p[d]{height:20}p[a],p[b],p[c],p[d]{border-radius:1in;background:#024817}body{background:#90d3a6}p{position:fixed}p[a]{top:204;left:100;width:200}p[b]{top:44;left:190;width:20;height:180}p[c]{left:186.5;rotate:-30deg;box-shadow:-25px 43.5px #024817}p[d]{right:186.5;rotate:30deg;box-shadow:25px 43.5px #024817',
}
